// import React, { useContext, useState } from "react";
// import { Link } from "react-router-dom";
// import logo from "../assets/images/WithName.png";
// import { AuthContext } from "../context/AuthContext";

// const about = [
//   { label: "Our Mission", path: "/mission" },
//   { label: "Our Vision", path: "/vision" },
//   { label: "Our Leadership Team", path: "/leadership-team" },
//   { label: "Our History", path: "/about" },
// ];

// const events = [
//   { label: "Upcoming Events", path: "/upcoming-events" },
//   { label: "Present Events", path: "/present-events" },
//   { label: "Past Events", path: "/past-events" },
// ];

// const facilities = [
//   { label: "Facilities for Guests", path: "/facilites-guests" },
//   { label: "Facilities for Members", path: "/facilites-members" },
// ];

// const content = [
//   { label: "Image Gallery", path: "/image-gallery" },
//   { label: "Video Gallery", path: "/video-gallery" },
// ];

// const Header = () => {
//   const [menuOpen, setMenuOpen] = useState(false);
//   // const [pagesOpen, setPagesOpen] = useState(false);
//   const [aboutPagesOpen, setAboutPagesOpen] = useState(false);
//   const [eventPages, setEventPages] = useState(false);
//   const [faciliteisOpen, setFacilitiesOpen] = useState(false);
//   const [contentisOpen, setContentisOpen] = useState(false);

//   // const isLoggedIn = localStorage.getItem("token");
//   const { isLoggedIn } = useContext(AuthContext);

//   return (
//     <header className="fixed w-full z-50 left-0 lg:text-[16px]">
//       <div className="bg-black/80 w-full backdrop-blur-lg px-6 md:px-12 flex items-center justify-between">
//         {/* Logo */}
//         <Link to="/" className="flex items-center justify-center space-x-2">
//           <img src={logo} alt="RGCC Logo" className="w-50 h-20" />
//         </Link>

//         {/* Desktop Nav */}
//         {/* <nav className="hidden md:flex items-center space-x-8 text-white font-semibold relative"> */}
//         <nav className="hidden md:flex flex-wrap gap-x-8 gap-y-4 text-white font-semibold relative">
//           <Link to="/" className="hover:text-green-500">
//             Home
//           </Link>
//           {/* <Link className="hover:text-green-500" to="/about">
//             About Us
//           </Link> */}
//           <div
//             className="relative group"
//             onMouseEnter={() => setAboutPagesOpen(true)}
//             onMouseLeave={() => setAboutPagesOpen(false)}
//           >
//             <button className="flex items-center space-x-1 text-white hover:text-green-500">
//               <span>About Us</span>
//               <svg
//                 className="w-4 h-4 mt-[2px]"
//                 fill="currentColor"
//                 viewBox="0 0 20 20"
//               >
//                 <path d="M5.25 7L10 11.75 14.75 7z" />
//               </svg>
//             </button>
//             {aboutPagesOpen && (
//               <div className="absolute left-0 top-[15px] mt-2 w-56 bg-lime-400 text-black p-4 rounded-xl space-y-2 z-50 shadow-xl">
//                 {about.map(({ label, path }, i) => (
//                   <Link
//                     onClick={() => setAboutPagesOpen(false)}
//                     key={i}
//                     to={path}
//                     className="block hover:underline"
//                   >
//                     {label}
//                   </Link>
//                 ))}
//               </div>
//             )}
//           </div>
//           <Link className="hover:text-green-500" to="/services">
//             Services
//           </Link>
//           <div
//             className="relative group"
//             onMouseEnter={() => setEventPages(true)}
//             onMouseLeave={() => setEventPages(false)}
//           >
//             <button className="flex items-center space-x-1 text-white hover:text-green-500">
//               <span>Events</span>
//               <svg
//                 className="w-4 h-4 mt-[2px]"
//                 fill="currentColor"
//                 viewBox="0 0 20 20"
//               >
//                 <path d="M5.25 7L10 11.75 14.75 7z" />
//               </svg>
//             </button>
//             {eventPages && (
//               <div className="absolute left-0 top-[15px] mt-2 w-56 bg-lime-400 text-black p-4 rounded-xl space-y-2 z-50 shadow-xl">
//                 {events.map(({ label, path }, i) => (
//                   <Link
//                     onClick={() => setEventPages(false)}
//                     key={i}
//                     to={path}
//                     className="block hover:underline"
//                   >
//                     {label}
//                   </Link>
//                 ))}
//               </div>
//             )}
//           </div>
//           <Link className="hover:text-green-500" to="/membership">
//             Membership
//           </Link>

//           <div
//             className="relative group"
//             onMouseEnter={() => setFacilitiesOpen(true)}
//             onMouseLeave={() => setFacilitiesOpen(false)}
//           >
//             <button className="flex items-center space-x-1 text-white hover:text-green-500">
//               <span>Facilities</span>
//               <svg
//                 className="w-4 h-4 mt-[2px]"
//                 fill="currentColor"
//                 viewBox="0 0 20 20"
//               >
//                 <path d="M5.25 7L10 11.75 14.75 7z" />
//               </svg>
//             </button>
//             {faciliteisOpen && (
//               <div className="absolute left-0 top-[15px] mt-2 w-56 bg-lime-400 text-black p-4 rounded-xl space-y-2 z-50 shadow-xl">
//                 {facilities.map(({ label, path }, i) => (
//                   <Link
//                     onClick={() => setFacilitiesOpen(false)}
//                     key={i}
//                     to={path}
//                     className="block hover:underline"
//                   >
//                     {label}
//                   </Link>
//                 ))}
//               </div>
//             )}
//           </div>

//           <Link className="hover:text-green-500" to="/golf-course">
//             Golf Course
//           </Link>

//           <div
//             className="relative group"
//             onMouseEnter={() => setContentisOpen(true)}
//             onMouseLeave={() => setContentisOpen(false)}
//           >
//             <button className="flex items-center space-x-1 text-white hover:text-green-500">
//               <span>Contents</span>
//               <svg
//                 className="w-4 h-4 mt-[2px]"
//                 fill="currentColor"
//                 viewBox="0 0 20 20"
//               >
//                 <path d="M5.25 7L10 11.75 14.75 7z" />
//               </svg>
//             </button>
//             {contentisOpen && (
//               <div className="absolute left-0 top-[15px] mt-2 w-56 bg-lime-400 text-black p-4 rounded-xl space-y-2 z-50 shadow-xl">
//                 {content.map(({ label, path }, i) => (
//                   <Link
//                     onClick={() => setContentisOpen(false)}
//                     key={i}
//                     to={path}
//                     className="block hover:underline"
//                   >
//                     {label}
//                   </Link>
//                 ))}
//               </div>
//             )}
//           </div>

//           <Link className="hover:text-green-500" to="/sponsors">
//             Sponsors
//           </Link>

//           <Link className="hover:text-green-500" to="/contact">
//             Contact Us
//           </Link>

//           {isLoggedIn ? (
//             <Link className="hover:text-green-500" to="/dashboard">
//               Dashboard
//             </Link>
//           ) : (
//             <Link className="hover:text-green-500" to="/login">
//               Login
//             </Link>
//           )}
//         </nav>

//         {/* Hamburger Menu (Mobile) */}
//         <button
//           className="md:hidden text-white"
//           onClick={() => setMenuOpen(!menuOpen)}
//         >
//           <svg
//             className="w-6 h-6"
//             fill="none"
//             stroke="currentColor"
//             viewBox="0 0 24 24"
//             strokeWidth={2}
//           >
//             {menuOpen ? (
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 d="M6 18L18 6M6 6l12 12"
//               />
//             ) : (
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 d="M4 6h16M4 12h16M4 18h16"
//               />
//             )}
//           </svg>
//         </button>
//       </div>

//       {/* Mobile Menu */}
//       {menuOpen && (
//         <div className="md:hidden bg-black/90 text-white px-6 py-4 space-y-3">
//           <Link
//             onClick={() => setMenuOpen(!menuOpen)}
//             to="/"
//             className="block "
//           >
//             Home
//           </Link>

//           <div>
//             <button
//               className="flex justify-between w-full text-left"
//               onClick={() => setAboutPagesOpen(!aboutPagesOpen)}
//             >
//               <span>About Us</span>
//               <span>{aboutPagesOpen ? "−" : "+"}</span>
//             </button>
//             {aboutPagesOpen && (
//               <div className="ml-4 mt-2 space-y-2 text-sm text-lime-300">
//                 {about.map(({ label, path }, i) => (
//                   <Link
//                     onClick={() => setMenuOpen(!menuOpen)}
//                     key={i}
//                     to={path}
//                     className="block hover:underline"
//                   >
//                     {label}
//                   </Link>
//                 ))}
//               </div>
//             )}
//           </div>
//           <Link
//             onClick={() => setMenuOpen(!menuOpen)}
//             to="/services"
//             className="block"
//           >
//             Services
//           </Link>

//           <div>
//             <button
//               className="flex justify-between w-full text-left"
//               onClick={() => setEventPages(!eventPages)}
//             >
//               <span>Events</span>
//               <span>{eventPages ? "−" : "+"}</span>
//             </button>
//             {eventPages && (
//               <div className="ml-4 mt-2 space-y-2 text-sm text-lime-300">
//                 {events.map(({ label, path }, i) => (
//                   <Link
//                     onClick={() => setMenuOpen(!menuOpen)}
//                     key={i}
//                     to={path}
//                     className="block hover:underline"
//                   >
//                     {label}
//                   </Link>
//                 ))}
//               </div>
//             )}
//           </div>
//           <Link
//             onClick={() => setMenuOpen(!menuOpen)}
//             className="block"
//             to="/membership"
//           >
//             Membership
//           </Link>

//           <div>
//             <button
//               className="flex justify-between w-full text-left"
//               onClick={() => setFacilitiesOpen(!faciliteisOpen)}
//             >
//               <span>Facilities</span>
//               <span>{faciliteisOpen ? "−" : "+"}</span>
//             </button>
//             {faciliteisOpen && (
//               <div className="ml-4 mt-2 space-y-2 text-sm text-lime-300">
//                 {facilities.map(({ label, path }, i) => (
//                   <Link
//                     onClick={() => setMenuOpen(!menuOpen)}
//                     key={i}
//                     to={path}
//                     className="block hover:underline"
//                   >
//                     {label}
//                   </Link>
//                 ))}
//               </div>
//             )}
//           </div>

//           <Link
//             onClick={() => setMenuOpen(!menuOpen)}
//             to="/golf-course"
//             className="block"
//           >
//             Golf Course
//           </Link>

//           <div>
//             <button
//               className="flex justify-between w-full text-left"
//               onClick={() => setContentisOpen(!contentisOpen)}
//             >
//               <span>Contents</span>
//               <span>{contentisOpen ? "−" : "+"}</span>
//             </button>
//             {contentisOpen && (
//               <div className="ml-4 mt-2 space-y-2 text-sm text-lime-300">
//                 {content.map(({ label, path }, i) => (
//                   <Link
//                     onClick={() => setMenuOpen(!menuOpen)}
//                     key={i}
//                     to={path}
//                     className="block hover:underline"
//                   >
//                     {label}
//                   </Link>
//                 ))}
//               </div>
//             )}
//           </div>

//           <Link
//             onClick={() => setMenuOpen(!menuOpen)}
//             to="/sponsors"
//             className="block"
//           >
//             Sponsors
//           </Link>

//           <Link
//             onClick={() => setMenuOpen(!menuOpen)}
//             to="/contact"
//             className="block"
//           >
//             Contact Us
//           </Link>

//           {isLoggedIn ? (
//             <Link
//               onClick={() => setMenuOpen(false)}
//               to="/dashboard"
//               className="block"
//             >
//               Dashboard
//             </Link>
//           ) : (
//             <Link
//               onClick={() => setMenuOpen(false)}
//               to="/login"
//               className="block"
//             >
//               Login
//             </Link>
//           )}
//         </div>
//       )}
//     </header>
//   );
// };

// export default Header;

// import React, { useContext, useState } from "react";
// import { Link } from "react-router-dom";
// import logo from "../assets/images/WithName.png";
// import { AuthContext } from "../context/AuthContext";

// const about = [
//   { label: "Our Mission", path: "/mission" },
//   { label: "Our Vision", path: "/vision" },
//   { label: "Our Leadership Team", path: "/leadership-team" },
//   { label: "Our History", path: "/about" },
// ];

// const events = [
//   { label: "Upcoming Events", path: "/upcoming-events" },
//   { label: "Present Events", path: "/present-events" },
//   { label: "Past Events", path: "/past-events" },
// ];

// const facilities = [
//   { label: "Facilities for Guests", path: "/facilites-guests" },
//   { label: "Facilities for Members", path: "/facilites-members" },
// ];

// const content = [
//   { label: "Image Gallery", path: "/image-gallery" },
//   { label: "Video Gallery", path: "/video-gallery" },
// ];

// const Header = () => {
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [aboutPagesOpen, setAboutPagesOpen] = useState(false);
//   const [eventPages, setEventPages] = useState(false);
//   const [faciliteisOpen, setFacilitiesOpen] = useState(false);
//   const [contentisOpen, setContentisOpen] = useState(false);

//   const { isLoggedIn } = useContext(AuthContext);

//   return (
//     <header className="fixed w-full z-50 left-0 lg:text-[16px]">
//       {/* Main Header */}
//       <div className="bg-gradient-to-r from-gray-900 to-black w-full backdrop-blur-lg px-6 md:px-16 py-3 flex items-center justify-between border-b border-gray-700">
//         {/* Logo */}
//         <Link to="/" className="flex items-center justify-center space-x-2">
//           <img
//             src={logo}
//             alt="RGCC Logo"
//             className="w-40 h-16 object-contain"
//           />
//         </Link>

//         {/* Desktop Navigation */}
//         <nav className="hidden lg:flex items-center space-x-10 text-white font-medium">
//           <Link
//             to="/"
//             className="hover:text-emerald-400 transition-colors duration-200 py-2"
//           >
//             Home
//           </Link>

//           {/* About Us Dropdown */}
//           <div
//             className="relative group"
//             onMouseEnter={() => setAboutPagesOpen(true)}
//             onMouseLeave={() => setAboutPagesOpen(false)}
//           >
//             <button className="flex items-center space-x-1 text-white hover:text-emerald-400 transition-colors duration-200 py-2">
//               <span>About Us</span>
//               <svg
//                 className={`w-4 h-4 transition-transform duration-200 ${
//                   aboutPagesOpen ? "rotate-180" : ""
//                 }`}
//                 fill="currentColor"
//                 viewBox="0 0 20 20"
//               >
//                 <path d="M5.25 7L10 11.75 14.75 7z" />
//               </svg>
//             </button>
//             <div
//               className={`absolute left-0 top-full mt-1 w-64 bg-white text-gray-800 p-4 rounded-xl space-y-3 z-50 shadow-2xl border border-gray-200 transition-all duration-200 ${
//                 aboutPagesOpen
//                   ? "opacity-100 visible transform translate-y-0"
//                   : "opacity-0 invisible transform -translate-y-2"
//               }`}
//               onMouseEnter={() => setAboutPagesOpen(true)}
//               onMouseLeave={() => setAboutPagesOpen(false)}
//             >
//               {about.map(({ label, path }, i) => (
//                 <Link
//                   onClick={() => setAboutPagesOpen(false)}
//                   key={i}
//                   to={path}
//                   className="block hover:text-emerald-600 hover:translate-x-1 transition-all duration-200 font-normal"
//                 >
//                   {label}
//                 </Link>
//               ))}
//             </div>
//           </div>

//           <Link
//             to="/services"
//             className="hover:text-emerald-400 transition-colors duration-200 py-2"
//           >
//             Services
//           </Link>

//           {/* Events Dropdown */}
//           <div
//             className="relative group"
//             onMouseEnter={() => setEventPages(true)}
//             onMouseLeave={() => setEventPages(false)}
//           >
//             <button className="flex items-center space-x-1 text-white hover:text-emerald-400 transition-colors duration-200 py-2">
//               <span>Events</span>
//               <svg
//                 className={`w-4 h-4 transition-transform duration-200 ${
//                   eventPages ? "rotate-180" : ""
//                 }`}
//                 fill="currentColor"
//                 viewBox="0 0 20 20"
//               >
//                 <path d="M5.25 7L10 11.75 14.75 7z" />
//               </svg>
//             </button>
//             <div
//               className={`absolute left-0 top-full mt-1 w-64 bg-white text-gray-800 p-4 rounded-xl space-y-3 z-50 shadow-2xl border border-gray-200 transition-all duration-200 ${
//                 eventPages
//                   ? "opacity-100 visible transform translate-y-0"
//                   : "opacity-0 invisible transform -translate-y-2"
//               }`}
//               onMouseEnter={() => setEventPages(true)}
//               onMouseLeave={() => setEventPages(false)}
//             >
//               {events.map(({ label, path }, i) => (
//                 <Link
//                   onClick={() => setEventPages(false)}
//                   key={i}
//                   to={path}
//                   className="block hover:text-emerald-600 hover:translate-x-1 transition-all duration-200 font-normal"
//                 >
//                   {label}
//                 </Link>
//               ))}
//             </div>
//           </div>

//           <Link
//             to="/membership"
//             className="hover:text-emerald-400 transition-colors duration-200 py-2"
//           >
//             Membership
//           </Link>

//           {/* Facilities Dropdown */}
//           <div
//             className="relative group"
//             onMouseEnter={() => setFacilitiesOpen(true)}
//             onMouseLeave={() => setFacilitiesOpen(false)}
//           >
//             <button className="flex items-center space-x-1 text-white hover:text-emerald-400 transition-colors duration-200 py-2">
//               <span>Facilities</span>
//               <svg
//                 className={`w-4 h-4 transition-transform duration-200 ${
//                   faciliteisOpen ? "rotate-180" : ""
//                 }`}
//                 fill="currentColor"
//                 viewBox="0 0 20 20"
//               >
//                 <path d="M5.25 7L10 11.75 14.75 7z" />
//               </svg>
//             </button>
//             <div
//               className={`absolute left-0 top-full mt-1 w-64 bg-white text-gray-800 p-4 rounded-xl space-y-3 z-50 shadow-2xl border border-gray-200 transition-all duration-200 ${
//                 faciliteisOpen
//                   ? "opacity-100 visible transform translate-y-0"
//                   : "opacity-0 invisible transform -translate-y-2"
//               }`}
//               onMouseEnter={() => setFacilitiesOpen(true)}
//               onMouseLeave={() => setFacilitiesOpen(false)}
//             >
//               {facilities.map(({ label, path }, i) => (
//                 <Link
//                   onClick={() => setFacilitiesOpen(false)}
//                   key={i}
//                   to={path}
//                   className="block hover:text-emerald-600 hover:translate-x-1 transition-all duration-200 font-normal"
//                 >
//                   {label}
//                 </Link>
//               ))}
//             </div>
//           </div>

//           <Link
//             to="/golf-course"
//             className="hover:text-emerald-400 transition-colors duration-200 py-2"
//           >
//             Golf Course
//           </Link>

//           {/* Content Dropdown */}
//           <div
//             className="relative group"
//             onMouseEnter={() => setContentisOpen(true)}
//             onMouseLeave={() => setContentisOpen(false)}
//           >
//             <button className="flex items-center space-x-1 text-white hover:text-emerald-400 transition-colors duration-200 py-2">
//               <span>Content</span>
//               <svg
//                 className={`w-4 h-4 transition-transform duration-200 ${
//                   contentisOpen ? "rotate-180" : ""
//                 }`}
//                 fill="currentColor"
//                 viewBox="0 0 20 20"
//               >
//                 <path d="M5.25 7L10 11.75 14.75 7z" />
//               </svg>
//             </button>
//             <div
//               className={`absolute left-0 top-full mt-1 w-64 bg-white text-gray-800 p-4 rounded-xl space-y-3 z-50 shadow-2xl border border-gray-200 transition-all duration-200 ${
//                 contentisOpen
//                   ? "opacity-100 visible transform translate-y-0"
//                   : "opacity-0 invisible transform -translate-y-2"
//               }`}
//               onMouseEnter={() => setContentisOpen(true)}
//               onMouseLeave={() => setContentisOpen(false)}
//             >
//               {content.map(({ label, path }, i) => (
//                 <Link
//                   onClick={() => setContentisOpen(false)}
//                   key={i}
//                   to={path}
//                   className="block hover:text-emerald-600 hover:translate-x-1 transition-all duration-200 font-normal"
//                 >
//                   {label}
//                 </Link>
//               ))}
//             </div>
//           </div>

//           <Link
//             to="/sponsors"
//             className="hover:text-emerald-400 transition-colors duration-200 py-2"
//           >
//             Sponsors
//           </Link>

//           <Link
//             to="/contact"
//             className="hover:text-emerald-400 transition-colors duration-200 py-2"
//           >
//             Contact
//           </Link>

//           {isLoggedIn ? (
//             <Link
//               to="/dashboard"
//               className="bg-emerald-500 hover:bg-emerald-600 text-white px-4 py-2 rounded-lg transition-colors duration-200 font-semibold"
//             >
//               Dashboard
//             </Link>
//           ) : (
//             <Link
//               to="/login"
//               className="bg-emerald-500 hover:bg-emerald-600 text-white px-4 py-2 rounded-lg transition-colors duration-200 font-semibold"
//             >
//               Login
//             </Link>
//           )}
//         </nav>

//         {/* Mobile Menu Button */}
//         <button
//           className="lg:hidden text-white p-2 hover:bg-gray-800 rounded-lg transition-colors duration-200"
//           onClick={() => setMenuOpen(!menuOpen)}
//         >
//           <svg
//             className="w-6 h-6"
//             fill="none"
//             stroke="currentColor"
//             viewBox="0 0 24 24"
//             strokeWidth={2}
//           >
//             {menuOpen ? (
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 d="M6 18L18 6M6 6l12 12"
//               />
//             ) : (
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 d="M4 6h16M4 12h16M4 18h16"
//               />
//             )}
//           </svg>
//         </button>
//       </div>

//       {/* Mobile Menu */}
//       {menuOpen && (
//         <div className="lg:hidden bg-gradient-to-b from-gray-900 to-black text-white px-6 py-6 space-y-4 border-b border-gray-700">
//           <Link
//             onClick={() => setMenuOpen(false)}
//             to="/"
//             className="block py-3 hover:text-emerald-400 transition-colors duration-200 border-b border-gray-700"
//           >
//             Home
//           </Link>

//           {/* Mobile About Us Dropdown */}
//           <div className="border-b border-gray-700">
//             <button
//               className="flex justify-between w-full text-left py-3 hover:text-emerald-400 transition-colors duration-200"
//               onClick={() => setAboutPagesOpen(!aboutPagesOpen)}
//             >
//               <span>About Us</span>
//               <span className="transform transition-transform duration-200">
//                 {aboutPagesOpen ? "−" : "+"}
//               </span>
//             </button>
//             {aboutPagesOpen && (
//               <div className="ml-4 mt-2 space-y-3 text-sm text-gray-300 pb-3">
//                 {about.map(({ label, path }, i) => (
//                   <Link
//                     onClick={() => setMenuOpen(false)}
//                     key={i}
//                     to={path}
//                     className="block py-2 hover:text-emerald-400 transition-colors duration-200"
//                   >
//                     {label}
//                   </Link>
//                 ))}
//               </div>
//             )}
//           </div>

//           <Link
//             onClick={() => setMenuOpen(false)}
//             to="/services"
//             className="block py-3 hover:text-emerald-400 transition-colors duration-200 border-b border-gray-700"
//           >
//             Services
//           </Link>

//           {/* Mobile Events Dropdown */}
//           <div className="border-b border-gray-700">
//             <button
//               className="flex justify-between w-full text-left py-3 hover:text-emerald-400 transition-colors duration-200"
//               onClick={() => setEventPages(!eventPages)}
//             >
//               <span>Events</span>
//               <span className="transform transition-transform duration-200">
//                 {eventPages ? "−" : "+"}
//               </span>
//             </button>
//             {eventPages && (
//               <div className="ml-4 mt-2 space-y-3 text-sm text-gray-300 pb-3">
//                 {events.map(({ label, path }, i) => (
//                   <Link
//                     onClick={() => setMenuOpen(false)}
//                     key={i}
//                     to={path}
//                     className="block py-2 hover:text-emerald-400 transition-colors duration-200"
//                   >
//                     {label}
//                   </Link>
//                 ))}
//               </div>
//             )}
//           </div>

//           <Link
//             onClick={() => setMenuOpen(false)}
//             className="block py-3 hover:text-emerald-400 transition-colors duration-200 border-b border-gray-700"
//             to="/membership"
//           >
//             Membership
//           </Link>

//           {/* Mobile Facilities Dropdown */}
//           <div className="border-b border-gray-700">
//             <button
//               className="flex justify-between w-full text-left py-3 hover:text-emerald-400 transition-colors duration-200"
//               onClick={() => setFacilitiesOpen(!faciliteisOpen)}
//             >
//               <span>Facilities</span>
//               <span className="transform transition-transform duration-200">
//                 {faciliteisOpen ? "−" : "+"}
//               </span>
//             </button>
//             {faciliteisOpen && (
//               <div className="ml-4 mt-2 space-y-3 text-sm text-gray-300 pb-3">
//                 {facilities.map(({ label, path }, i) => (
//                   <Link
//                     onClick={() => setMenuOpen(false)}
//                     key={i}
//                     to={path}
//                     className="block py-2 hover:text-emerald-400 transition-colors duration-200"
//                   >
//                     {label}
//                   </Link>
//                 ))}
//               </div>
//             )}
//           </div>

//           <Link
//             onClick={() => setMenuOpen(false)}
//             to="/golf-course"
//             className="block py-3 hover:text-emerald-400 transition-colors duration-200 border-b border-gray-700"
//           >
//             Golf Course
//           </Link>

//           {/* Mobile Content Dropdown */}
//           <div className="border-b border-gray-700">
//             <button
//               className="flex justify-between w-full text-left py-3 hover:text-emerald-400 transition-colors duration-200"
//               onClick={() => setContentisOpen(!contentisOpen)}
//             >
//               <span>Content</span>
//               <span className="transform transition-transform duration-200">
//                 {contentisOpen ? "−" : "+"}
//               </span>
//             </button>
//             {contentisOpen && (
//               <div className="ml-4 mt-2 space-y-3 text-sm text-gray-300 pb-3">
//                 {content.map(({ label, path }, i) => (
//                   <Link
//                     onClick={() => setMenuOpen(false)}
//                     key={i}
//                     to={path}
//                     className="block py-2 hover:text-emerald-400 transition-colors duration-200"
//                   >
//                     {label}
//                   </Link>
//                 ))}
//               </div>
//             )}
//           </div>

//           <Link
//             onClick={() => setMenuOpen(false)}
//             to="/sponsors"
//             className="block py-3 hover:text-emerald-400 transition-colors duration-200 border-b border-gray-700"
//           >
//             Sponsors
//           </Link>

//           <Link
//             onClick={() => setMenuOpen(false)}
//             to="/contact"
//             className="block py-3 hover:text-emerald-400 transition-colors duration-200 border-b border-gray-700"
//           >
//             Contact
//           </Link>

//           <div className="pt-4 border-t border-gray-700">
//             {isLoggedIn ? (
//               <Link
//                 onClick={() => setMenuOpen(false)}
//                 to="/dashboard"
//                 className="block w-full bg-emerald-500 hover:bg-emerald-600 text-white text-center py-3 rounded-lg transition-colors duration-200 font-semibold"
//               >
//                 Dashboard
//               </Link>
//             ) : (
//               <Link
//                 onClick={() => setMenuOpen(false)}
//                 to="/login"
//                 className="block w-full bg-emerald-500 hover:bg-emerald-600 text-white text-center py-3 rounded-lg transition-colors duration-200 font-semibold"
//               >
//                 Login
//               </Link>
//             )}
//           </div>
//         </div>
//       )}
//     </header>
//   );
// };

// export default Header;
import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/images/WithName.png";
import { AuthContext } from "../context/AuthContext";

const about = [
  { label: "Our Mission", path: "/mission" },
  { label: "Our Vision", path: "/vision" },
  { label: "Our Leadership Team", path: "/leadership-team" },
  { label: "Our History", path: "/about" },
];

const events = [
  { label: "Upcoming Events", path: "/upcoming-events" },
  { label: "Present Events", path: "/present-events" },
  { label: "Past Events", path: "/past-events" },
];

const facilities = [
  { label: "Facilities for Guests", path: "/facilites-guests" },
  { label: "Facilities for Members", path: "/facilites-members" },
];

const content = [
  { label: "Image Gallery", path: "/image-gallery" },
  { label: "Video Gallery", path: "/video-gallery" },
];

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [aboutPagesOpen, setAboutPagesOpen] = useState(false);
  const [eventPages, setEventPages] = useState(false);
  const [faciliteisOpen, setFacilitiesOpen] = useState(false);
  const [contentisOpen, setContentisOpen] = useState(false);

  const { isLoggedIn } = useContext(AuthContext);

  // Close all dropdowns when menu closes
  const closeAllDropdowns = () => {
    setAboutPagesOpen(false);
    setEventPages(false);
    setFacilitiesOpen(false);
    setContentisOpen(false);
  };

  const handleMenuToggle = () => {
    setMenuOpen(!menuOpen);
    if (!menuOpen) {
      closeAllDropdowns();
    }
  };

  const handleLinkClick = () => {
    setMenuOpen(false);
    closeAllDropdowns();
  };

  return (
    <header className="fixed w-full z-50 left-0 lg:text-[16px]">
      {/* Main Header */}
      <div className="bg-gradient-to-r from-gray-900 to-black w-full backdrop-blur-lg px-6 md:px-16 py-3 flex items-center justify-between border-b border-gray-700">
        {/* Logo */}
        <Link to="/" className="flex items-center justify-center space-x-2">
          <img
            src={logo}
            alt="RGCC Logo"
            className="w-40 h-16 object-contain"
          />
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex items-center space-x-10 text-white font-medium">
          <Link
            to="/"
            className="hover:text-emerald-400 transition-colors duration-200 py-2"
          >
            Home
          </Link>

          {/* About Us Dropdown */}
          <div
            className="relative group"
            onMouseEnter={() => setAboutPagesOpen(true)}
            onMouseLeave={() => setAboutPagesOpen(false)}
          >
            <button className="flex items-center space-x-1 text-white hover:text-emerald-400 transition-colors duration-200 py-2">
              <span>About Us</span>
              <svg
                className={`w-4 h-4 transition-transform duration-200 ${
                  aboutPagesOpen ? "rotate-180" : ""
                }`}
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M5.25 7L10 11.75 14.75 7z" />
              </svg>
            </button>
            <div
              className={`absolute left-0 top-full mt-1 w-64 bg-white text-gray-800 p-4 rounded-xl space-y-3 z-50 shadow-2xl border border-gray-200 transition-all duration-200 ${
                aboutPagesOpen
                  ? "opacity-100 visible transform translate-y-0"
                  : "opacity-0 invisible transform -translate-y-2"
              }`}
              onMouseEnter={() => setAboutPagesOpen(true)}
              onMouseLeave={() => setAboutPagesOpen(false)}
            >
              {about.map(({ label, path }, i) => (
                <Link
                  onClick={() => setAboutPagesOpen(false)}
                  key={i}
                  to={path}
                  className="block hover:text-emerald-600 hover:translate-x-1 transition-all duration-200 font-normal"
                >
                  {label}
                </Link>
              ))}
            </div>
          </div>

          <Link
            to="/services"
            className="hover:text-emerald-400 transition-colors duration-200 py-2"
          >
            Services
          </Link>

          {/* Events Dropdown */}
          <div
            className="relative group"
            onMouseEnter={() => setEventPages(true)}
            onMouseLeave={() => setEventPages(false)}
          >
            <button className="flex items-center space-x-1 text-white hover:text-emerald-400 transition-colors duration-200 py-2">
              <span>Events</span>
              <svg
                className={`w-4 h-4 transition-transform duration-200 ${
                  eventPages ? "rotate-180" : ""
                }`}
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M5.25 7L10 11.75 14.75 7z" />
              </svg>
            </button>
            <div
              className={`absolute left-0 top-full mt-1 w-64 bg-white text-gray-800 p-4 rounded-xl space-y-3 z-50 shadow-2xl border border-gray-200 transition-all duration-200 ${
                eventPages
                  ? "opacity-100 visible transform translate-y-0"
                  : "opacity-0 invisible transform -translate-y-2"
              }`}
              onMouseEnter={() => setEventPages(true)}
              onMouseLeave={() => setEventPages(false)}
            >
              {events.map(({ label, path }, i) => (
                <Link
                  onClick={() => setEventPages(false)}
                  key={i}
                  to={path}
                  className="block hover:text-emerald-600 hover:translate-x-1 transition-all duration-200 font-normal"
                >
                  {label}
                </Link>
              ))}
            </div>
          </div>

          <Link
            to="/membership"
            className="hover:text-emerald-400 transition-colors duration-200 py-2"
          >
            Membership
          </Link>

          {/* Facilities Dropdown */}
          <div
            className="relative group"
            onMouseEnter={() => setFacilitiesOpen(true)}
            onMouseLeave={() => setFacilitiesOpen(false)}
          >
            <button className="flex items-center space-x-1 text-white hover:text-emerald-400 transition-colors duration-200 py-2">
              <span>Facilities</span>
              <svg
                className={`w-4 h-4 transition-transform duration-200 ${
                  faciliteisOpen ? "rotate-180" : ""
                }`}
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M5.25 7L10 11.75 14.75 7z" />
              </svg>
            </button>
            <div
              className={`absolute left-0 top-full mt-1 w-64 bg-white text-gray-800 p-4 rounded-xl space-y-3 z-50 shadow-2xl border border-gray-200 transition-all duration-200 ${
                faciliteisOpen
                  ? "opacity-100 visible transform translate-y-0"
                  : "opacity-0 invisible transform -translate-y-2"
              }`}
              onMouseEnter={() => setFacilitiesOpen(true)}
              onMouseLeave={() => setFacilitiesOpen(false)}
            >
              {facilities.map(({ label, path }, i) => (
                <Link
                  onClick={() => setFacilitiesOpen(false)}
                  key={i}
                  to={path}
                  className="block hover:text-emerald-600 hover:translate-x-1 transition-all duration-200 font-normal"
                >
                  {label}
                </Link>
              ))}
            </div>
          </div>

          <Link
            to="/golf-course"
            className="hover:text-emerald-400 transition-colors duration-200 py-2"
          >
            Golf Course
          </Link>

          {/* Content Dropdown */}
          <div
            className="relative group"
            onMouseEnter={() => setContentisOpen(true)}
            onMouseLeave={() => setContentisOpen(false)}
          >
            <button className="flex items-center space-x-1 text-white hover:text-emerald-400 transition-colors duration-200 py-2">
              <span>Content</span>
              <svg
                className={`w-4 h-4 transition-transform duration-200 ${
                  contentisOpen ? "rotate-180" : ""
                }`}
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M5.25 7L10 11.75 14.75 7z" />
              </svg>
            </button>
            <div
              className={`absolute left-0 top-full mt-1 w-64 bg-white text-gray-800 p-4 rounded-xl space-y-3 z-50 shadow-2xl border border-gray-200 transition-all duration-200 ${
                contentisOpen
                  ? "opacity-100 visible transform translate-y-0"
                  : "opacity-0 invisible transform -translate-y-2"
              }`}
              onMouseEnter={() => setContentisOpen(true)}
              onMouseLeave={() => setContentisOpen(false)}
            >
              {content.map(({ label, path }, i) => (
                <Link
                  onClick={() => setContentisOpen(false)}
                  key={i}
                  to={path}
                  className="block hover:text-emerald-600 hover:translate-x-1 transition-all duration-200 font-normal"
                >
                  {label}
                </Link>
              ))}
            </div>
          </div>

          <Link
            to="/sponsors"
            className="hover:text-emerald-400 transition-colors duration-200 py-2"
          >
            Sponsors
          </Link>

          <Link
            to="/contact"
            className="hover:text-emerald-400 transition-colors duration-200 py-2"
          >
            Contact
          </Link>

          {isLoggedIn ? (
            <Link
              to="/dashboard"
              className="bg-emerald-500 hover:bg-emerald-600 text-white px-4 py-2 rounded-lg transition-colors duration-200 font-semibold"
            >
              Dashboard
            </Link>
          ) : (
            <Link
              to="/login"
              className="bg-emerald-500 hover:bg-emerald-600 text-white px-4 py-2 rounded-lg transition-colors duration-200 font-semibold"
            >
              Login
            </Link>
          )}
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="lg:hidden text-white p-2 hover:bg-gray-800 rounded-lg transition-colors duration-200"
          onClick={handleMenuToggle}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            strokeWidth={2}
          >
            {menuOpen ? (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            ) : (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4 6h16M4 12h16M4 18h16"
              />
            )}
          </svg>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="lg:hidden fixed text-white inset-0 top-[88px] bg-gradient-to-b from-gray-900 to-black">
          {/* Scrollable Container */}
          <div className="h-full overflow-y-auto pb-20">
            <div className="px-6 py-4 space-y-0">
              <Link
                onClick={handleLinkClick}
                to="/"
                className="block py-4 hover:text-emerald-400 transition-colors duration-200 border-b border-gray-700"
              >
                Home
              </Link>

              {/* Mobile About Us Dropdown */}
              <div className="border-b border-gray-700">
                <button
                  className="flex justify-between w-full text-left py-4 hover:text-emerald-400 transition-colors duration-200"
                  onClick={() => setAboutPagesOpen(!aboutPagesOpen)}
                >
                  <span>About Us</span>
                  <span className="transform transition-transform duration-200">
                    {aboutPagesOpen ? "−" : "+"}
                  </span>
                </button>
                {aboutPagesOpen && (
                  <div className="ml-4 mt-1 space-y-2 text-sm text-gray-300 pb-2">
                    {about.map(({ label, path }, i) => (
                      <Link
                        onClick={handleLinkClick}
                        key={i}
                        to={path}
                        className="block py-3 hover:text-emerald-400 transition-colors duration-200 border-b border-gray-600"
                      >
                        {label}
                      </Link>
                    ))}
                  </div>
                )}
              </div>

              <Link
                onClick={handleLinkClick}
                to="/services"
                className="block py-4 hover:text-emerald-400 transition-colors duration-200 border-b border-gray-700"
              >
                Services
              </Link>

              {/* Mobile Events Dropdown */}
              <div className="border-b border-gray-700">
                <button
                  className="flex justify-between w-full text-left py-4 hover:text-emerald-400 transition-colors duration-200"
                  onClick={() => setEventPages(!eventPages)}
                >
                  <span>Events</span>
                  <span className="transform transition-transform duration-200">
                    {eventPages ? "−" : "+"}
                  </span>
                </button>
                {eventPages && (
                  <div className="ml-4 mt-1 space-y-2 text-sm text-gray-300 pb-2">
                    {events.map(({ label, path }, i) => (
                      <Link
                        onClick={handleLinkClick}
                        key={i}
                        to={path}
                        className="block py-3 hover:text-emerald-400 transition-colors duration-200 border-b border-gray-600"
                      >
                        {label}
                      </Link>
                    ))}
                  </div>
                )}
              </div>

              <Link
                onClick={handleLinkClick}
                className="block py-4 hover:text-emerald-400 transition-colors duration-200 border-b border-gray-700"
                to="/membership"
              >
                Membership
              </Link>

              {/* Mobile Facilities Dropdown */}
              <div className="border-b border-gray-700">
                <button
                  className="flex justify-between w-full text-left py-4 hover:text-emerald-400 transition-colors duration-200"
                  onClick={() => setFacilitiesOpen(!faciliteisOpen)}
                >
                  <span>Facilities</span>
                  <span className="transform transition-transform duration-200">
                    {faciliteisOpen ? "−" : "+"}
                  </span>
                </button>
                {faciliteisOpen && (
                  <div className="ml-4 mt-1 space-y-2 text-sm text-gray-300 pb-2">
                    {facilities.map(({ label, path }, i) => (
                      <Link
                        onClick={handleLinkClick}
                        key={i}
                        to={path}
                        className="block py-3 hover:text-emerald-400 transition-colors duration-200 border-b border-gray-600"
                      >
                        {label}
                      </Link>
                    ))}
                  </div>
                )}
              </div>

              <Link
                onClick={handleLinkClick}
                to="/golf-course"
                className="block py-4 hover:text-emerald-400 transition-colors duration-200 border-b border-gray-700"
              >
                Golf Course
              </Link>

              {/* Mobile Content Dropdown */}
              <div className="border-b border-gray-700">
                <button
                  className="flex justify-between w-full text-left py-4 hover:text-emerald-400 transition-colors duration-200"
                  onClick={() => setContentisOpen(!contentisOpen)}
                >
                  <span>Content</span>
                  <span className="transform transition-transform duration-200">
                    {contentisOpen ? "−" : "+"}
                  </span>
                </button>
                {contentisOpen && (
                  <div className="ml-4 mt-1 space-y-2 text-sm text-gray-300 pb-2">
                    {content.map(({ label, path }, i) => (
                      <Link
                        onClick={handleLinkClick}
                        key={i}
                        to={path}
                        className="block py-3 hover:text-emerald-400 transition-colors duration-200 border-b border-gray-600"
                      >
                        {label}
                      </Link>
                    ))}
                  </div>
                )}
              </div>

              <Link
                onClick={handleLinkClick}
                to="/sponsors"
                className="block py-4 hover:text-emerald-400 transition-colors duration-200 border-b border-gray-700"
              >
                Sponsors
              </Link>

              <Link
                onClick={handleLinkClick}
                to="/contact"
                className="block py-4 hover:text-emerald-400 transition-colors duration-200 border-b border-gray-700"
              >
                Contact
              </Link>

              <div className="pt-6 border-t border-gray-700">
                {isLoggedIn ? (
                  <Link
                    onClick={handleLinkClick}
                    to="/dashboard"
                    className="block w-full bg-emerald-500 hover:bg-emerald-600 text-white text-center py-4 rounded-lg transition-colors duration-200 font-semibold mb-3"
                  >
                    Dashboard
                  </Link>
                ) : (
                  <Link
                    onClick={handleLinkClick}
                    to="/login"
                    className="block w-full bg-emerald-500 hover:bg-emerald-600 text-white text-center py-4 rounded-lg transition-colors duration-200 font-semibold mb-3"
                  >
                    Login
                  </Link>
                )}

                {/* Close Menu Button */}
                {/* <button
                  onClick={handleMenuToggle}
                  className="block w-full bg-gray-700 hover:bg-gray-600 text-white text-center py-4 rounded-lg transition-colors duration-200 font-semibold"
                >
                  Close Menu
                </button> */}
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
